<headline-with-icon-and-info-box
  [icon]="'warn'"
  [headline]="'APPOI.PAGE_NOT_FOUND.HEADLINE' | translate"
  [infoBoxHeadline]="'APPOI.PAGE_NOT_FOUND.DESCRIPTION' | translate"
>
</headline-with-icon-and-info-box>
